import React from "react";
import { useIntl } from "react-intl";

import CustomIcon from "../customIcon";

const StateIcon = ({ valid, close, messages, className }) => {
  const intl = useIntl();
  return (
    <CustomIcon
      className={className}
      color={valid ? "green" : "red"}
      type={valid ? "check" : close ? "close" : "warning"}
      title={
        (messages && messages[0]) ||
        (valid
          ? intl.formatMessage({
              id: "messages.allCorect",
              defaultMessage: "Všechny zadané hodnoty jsou v pořádku.",
            })
          : intl.formatMessage({
              id: "messages.someIncorrect",
              defaultMessage:
                "Tento blok obsahuje chybějící nebo chybně zadané hodnoty!",
            }))
      }
    />
  );
};

export default StateIcon;
